import { render, staticRenderFns } from "./FakeLogin.vue?vue&type=template&id=f664a1c6&"
import script from "./FakeLogin.vue?vue&type=script&lang=js&"
export * from "./FakeLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports